import { valueWithIva } from '@utils/format'

// Função de arredondamento inteligente (máximo 6 casas decimais, remove zeros à direita)
const smartRound = (value, maxDecimals = 6) => {
    // Verificar se o valor é válido e numérico
    if (value === null || value === undefined || value === '' || isNaN(value)) return 0;
    
    // Converter para número se for string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    // Verificar se é um número válido
    if (isNaN(numValue) || numValue === 0) return 0;
    
    // Arredondar para maxDecimals casas decimais usando Math.round para evitar problemas de precisão
    const factor = Math.pow(10, maxDecimals);
    const rounded = Math.round(numValue * factor) / factor;
    
    // Converter para string e depois para número para remover zeros à direita
    // Exemplo: 1.230 vira 1.23, 1.234 fica 1.234
    const result = parseFloat(rounded.toString());
    
    return result;
};

const getRealValue = (price, originalPrice) => {
    return price ? smartRound(price, 6) : smartRound(originalPrice, 6)
}

export const totals = (lines, doctype, taxes=[]) => (lines || []).reduce((results, line) => {
    const desc = smartRound(line.desc, 6);
    const desc1 = smartRound(line.desc1, 6);
    const desc2 = smartRound(line.desc2, 6);
    
    // Para transferências, usar o preço de custo do posto origem (costprice_source)
    let costprice;
    if (doctype === 'transfer') {
        costprice = getRealValue(line.costprice_source || line.costprice, (line.product || {}).costprice);
    } else if (['orders', 'returns', 'inventory'].indexOf(doctype) >= 0) {
        costprice = getRealValue(line.costprice, (line.product || {}).costprice);
    } else {
        costprice = getRealValue(line.price, (line.product || {}).price);
    }
    
    const quantity = smartRound(line.quantity, 6);
    
    // Tentar diferentes formas de obter a taxa de IVA
    let ivaTax = 0;
    if (line.iva) {
        if (typeof line.iva === 'object') {
            // Se line.iva é um objeto, usar a propriedade tax
            ivaTax = line.iva.tax || 0;
        } else {
            // Se line.iva é um número, procurar nas taxes
            ivaTax = (taxes.find((tax) => tax.code === line.iva) || { tax: 0 }).tax;
        }
    }
    
    const taxtaIva = ivaTax;

    const subtotal = smartRound(costprice * quantity, 6);
    
    // Inicializar ivas por taxa se não existir
    if (!results.ivas) {
        results.ivas = {};
    }
    
    // Para transferências: total s/IVA (subtotal) e total c/IVA (com IVA), sem descontos
    if (doctype === 'transfer') {
        const totalWithoutIVA = subtotal;
        const total = valueWithIva(totalWithoutIVA, taxtaIva);
        const iva = smartRound(total - totalWithoutIVA, 6);
        
        // Adicionar IVA por taxa
        if (taxtaIva > 0 && iva > 0) {
            const taxKey = `${taxtaIva}%`;
            if (!results.ivas[taxKey]) {
                results.ivas[taxKey] = 0;
            }
            results.ivas[taxKey] = smartRound(results.ivas[taxKey] + iva, 6);
        }
        
        return {
            total: smartRound(results.total + total, 6),
            subtotal: smartRound(results.subtotal + totalWithoutIVA, 6),
            desconto: results.desconto,
            iva: smartRound(results.iva + iva, 6),
            ivas: results.ivas,
        };
    }
    
    // Calcular desconto diretamente do subtotal para evitar erros de precisão
    // Aplicar descontos sequencialmente no subtotal
    let desconto = 0;
    let subtotalWithDiscount = subtotal;
    
    if (desc1 > 0) {
        const desc1Amount = smartRound(subtotal * (desc1 / 100), 6);
        desconto = smartRound(desconto + desc1Amount, 6);
        subtotalWithDiscount = smartRound(subtotalWithDiscount - desc1Amount, 6);
    }
    
    if (desc2 > 0) {
        const desc2Amount = smartRound(subtotalWithDiscount * (desc2 / 100), 6);
        desconto = smartRound(desconto + desc2Amount, 6);
        subtotalWithDiscount = smartRound(subtotalWithDiscount - desc2Amount, 6);
    }
    
    if (desc > 0) {
        const descAmount = smartRound(desc * quantity, 6);
        desconto = smartRound(desconto + descAmount, 6);
        subtotalWithDiscount = smartRound(subtotalWithDiscount - descAmount, 6);
    }

    const totalWithoutIVA = smartRound(subtotal - desconto, 6);
    // Usar o total_civa da linha se disponível, senão calcular
    const total = line.total_civa ? smartRound(line.total_civa, 6) : valueWithIva(totalWithoutIVA, taxtaIva);
    const iva = smartRound(total - totalWithoutIVA, 6);

    // Adicionar IVA por taxa
    if (taxtaIva > 0 && iva > 0) {
        const taxKey = `${taxtaIva}%`;
        if (!results.ivas[taxKey]) {
            results.ivas[taxKey] = 0;
        }
        results.ivas[taxKey] = smartRound(results.ivas[taxKey] + iva, 2);
    }

    return {
        total: smartRound(results.total + total, 6),
        subtotal: smartRound(results.subtotal + subtotal, 6),
        desconto: smartRound(results.desconto + desconto, 6),
        iva: smartRound(results.iva + iva, 6),
        ivas: results.ivas,
    };
}, {
    total: 0,
    subtotal: 0,
    desconto: 0,
    iva: 0,
    ivas: {},
});